/**
 * Fallback Calendar Data
 * 
 * Provides static offline/fallback calendar definitions for school years (holidays, breaks, special days, camps).
 * Used when Supabase DB is unreachable or before migrations are applied.
 */

export interface FallbackCalendarItem {
  date: string // Format: 'YYYY-MM-DD'
  name: string
  type: 'holiday' | 'break' | 'special' | 'saturday' | 'camp'
  description?: string
}

// ============================================================================
// School Year 2025-2026 (תשפ"ו)
// ============================================================================
export const CALENDAR_2025_2026: FallbackCalendarItem[] = [
  // --- ראש השנה תשפ"ו ---
  { date: '2025-09-22', name: 'ערב ראש השנה', type: 'holiday' },
  { date: '2025-09-23', name: 'ראש השנה א\'', type: 'holiday' },
  { date: '2025-09-24', name: 'ראש השנה ב\'', type: 'holiday' },

  // --- יום הכיפורים תשפ"ו ---
  { date: '2025-10-01', name: 'ערב יום הכיפורים', type: 'holiday' },
  { date: '2025-10-02', name: 'יום הכיפורים', type: 'holiday' },

  // --- ימי חופשה בין כיפור לסוכות ---
  { date: '2025-10-03', name: 'חופשה בין החגים', type: 'break' },
  { date: '2025-10-04', name: 'חופשה בין החגים', type: 'break' },
  { date: '2025-10-05', name: 'קייטנת סוכות', type: 'camp', description: 'פעילות צהרון' },

  // --- סוכות תשפ"ו ---
  { date: '2025-10-06', name: 'ערב סוכות', type: 'holiday' },
  { date: '2025-10-07', name: 'סוכות א\'', type: 'holiday' },
  { date: '2025-10-08', name: 'חול המועד סוכות', type: 'holiday' },
  { date: '2025-10-09', name: 'חול המועד סוכות', type: 'holiday' },
  { date: '2025-10-10', name: 'חול המועד סוכות', type: 'holiday' },
  { date: '2025-10-11', name: 'חול המועד סוכות', type: 'holiday' },
  { date: '2025-10-12', name: 'חול המועד סוכות', type: 'holiday' },
  { date: '2025-10-13', name: 'הושענא רבה', type: 'holiday' },
  { date: '2025-10-14', name: 'שמחת תורה', type: 'holiday' },

  // --- חג הסיגד ---
  { date: '2025-11-20', name: 'חג הסיגד', type: 'special' },

  // --- חנוכה תשפ"ו ---
  { date: '2025-12-16', name: 'קייטנת חנוכה', type: 'camp' },
  { date: '2025-12-17', name: 'קייטנת חנוכה', type: 'camp' },
  { date: '2025-12-18', name: 'קייטנת חנוכה', type: 'camp' },
  { date: '2025-12-19', name: 'חנוכה - חופשה', type: 'break' },
  { date: '2025-12-20', name: 'חנוכה - חופשה', type: 'break' },
  { date: '2025-12-21', name: 'קייטנת חנוכה', type: 'camp' },
  { date: '2025-12-22', name: 'קייטנת חנוכה', type: 'camp' },

  // --- ט"ו בשבט ---
  { date: '2026-02-02', name: 'ט"ו בשבט', type: 'special' },

  // --- פורים תשפ"ו ---
  { date: '2026-03-03', name: 'פורים', type: 'holiday' },
  { date: '2026-03-04', name: 'קייטנת פורים', type: 'camp' },

  // --- פסח תשפ"ו ---
  { date: '2026-03-24', name: 'קייטנת פסח', type: 'camp' },
  { date: '2026-03-25', name: 'קייטנת פסח', type: 'camp' },
  { date: '2026-03-26', name: 'קייטנת פסח', type: 'camp' },
  { date: '2026-03-27', name: 'חול המועד פסח', type: 'holiday' },
  { date: '2026-03-28', name: 'חול המועד פסח', type: 'holiday' },
  { date: '2026-03-29', name: 'קייטנת פסח', type: 'camp' },
  { date: '2026-03-30', name: 'קייטנת פסח', type: 'camp' },
  { date: '2026-03-31', name: 'פסח ז\'', type: 'holiday' },
  { date: '2026-04-01', name: 'איסרו חג פסח', type: 'holiday' },
  { date: '2026-04-02', name: 'חופשת פסח', type: 'break' },
  { date: '2026-04-03', name: 'חופשת פסח', type: 'break' },
  { date: '2026-04-04', name: 'חופשת פסח', type: 'break' },
  { date: '2026-04-05', name: 'חופשת פסח', type: 'break' },
  { date: '2026-04-06', name: 'חופשת פסח', type: 'break' },
  { date: '2026-04-07', name: 'חופשת פסח', type: 'break' },
  { date: '2026-04-08', name: 'חופשת פסח', type: 'break' },

  // --- יום העצמאות תשפ"ו ---
  { date: '2026-04-22', name: 'יום העצמאות', type: 'holiday' },

  // --- ל"ג בעומר תשפ"ו ---
  { date: '2026-05-05', name: 'קייטנת ל"ג בעומר', type: 'camp' },

  // --- יום ירושלים ---
  { date: '2026-05-15', name: 'יום ירושלים', type: 'special' },

  // --- שבועות תשפ"ו ---
  { date: '2026-05-21', name: 'ערב שבועות', type: 'holiday' },
  { date: '2026-05-22', name: 'חג השבועות', type: 'holiday' }
]

// ============================================================================
// School Year 2026-2027 (תשפ"ז) - Official Tel Aviv-Yafo Vacation Activity Schedule
// ============================================================================
export const CALENDAR_2026_2027: FallbackCalendarItem[] = [
  // --- ראש השנה תשפ"ז (אין פעילות צהרון) ---
  { date: '2026-09-11', name: 'ערב ראש השנה', type: 'holiday', description: 'ערב ראש השנה תשפ"ז - אין פעילות צהרון' },
  { date: '2026-09-12', name: 'ראש השנה א\'', type: 'holiday', description: 'ראש השנה א\' - אין פעילות צהרון' },
  { date: '2026-09-13', name: 'ראש השנה ב\'', type: 'holiday', description: 'ראש השנה ב\' - אין פעילות צהרון' },

  // --- יום כיפור תשפ"ז (אין פעילות צהרון) ---
  { date: '2026-09-20', name: 'ערב יום כיפור', type: 'holiday', description: 'ערב יום כיפור - אין פעילות צהרון' },
  { date: '2026-09-21', name: 'יום כיפור', type: 'holiday', description: 'יום כיפור - אין פעילות צהרון' },

  // --- גשר כיפור-סוכות (קייטנה - פעילות מלאה בצהרון) ---
  { date: '2026-09-22', name: 'קייטנת גשר כיפור-סוכות', type: 'camp', description: 'פעילות מלאה בצהרון' },
  { date: '2026-09-23', name: 'קייטנת גשר כיפור-סוכות', type: 'camp', description: 'פעילות מלאה בצהרון' },
  { date: '2026-09-24', name: 'קייטנת גשר כיפור-סוכות', type: 'camp', description: 'פעילות מלאה בצהרון' },

  // --- סוכות תשפ"ז (אין פעילות צהרון) ---
  { date: '2026-09-25', name: 'ערב סוכות', type: 'holiday', description: 'ערב סוכות - אין פעילות צהרון' },
  { date: '2026-09-26', name: 'סוכות א\'', type: 'holiday', description: 'סוכות א\' - אין פעילות צהרון' },
  { date: '2026-09-27', name: 'חול המועד סוכות', type: 'holiday', description: 'חול המועד סוכות - אין פעילות צהרון' },
  { date: '2026-09-28', name: 'חול המועד סוכות', type: 'holiday', description: 'חול המועד סוכות - אין פעילות צהרון' },
  { date: '2026-09-29', name: 'חול המועד סוכות', type: 'holiday', description: 'חול המועד סוכות - אין פעילות צהרון' },
  { date: '2026-09-30', name: 'חול המועד סוכות', type: 'holiday', description: 'חול המועד סוכות - אין פעילות צהרון' },
  { date: '2026-10-01', name: 'הושענא רבה', type: 'holiday', description: 'הושענא רבה - אין פעילות צהרון' },
  { date: '2026-10-02', name: 'שמחת תורה', type: 'holiday', description: 'שמחת תורה - אין פעילות צהרון' },
  { date: '2026-10-03', name: 'אסרו חג סוכות', type: 'break', description: 'אסרו חג סוכות - אין פעילות צהרון' },

  // --- חנוכה תשפ"ז (קייטנה א'-ה', חופשה בשישי-שבת) ---
  { date: '2026-12-06', name: 'קייטנת חנוכה', type: 'camp', description: 'פעילות מלאה בצהרון' },
  { date: '2026-12-07', name: 'קייטנת חנוכה', type: 'camp', description: 'פעילות מלאה בצהרון' },
  { date: '2026-12-08', name: 'קייטנת חנוכה', type: 'camp', description: 'פעילות מלאה בצהרון' },
  { date: '2026-12-09', name: 'קייטנת חנוכה', type: 'camp', description: 'פעילות מלאה בצהרון' },
  { date: '2026-12-10', name: 'קייטנת חנוכה', type: 'camp', description: 'פעילות מלאה בצהרון' },
  { date: '2026-12-11', name: 'חופשת חנוכה', type: 'break', description: 'חופשת חנוכה - אין פעילות צהרון בשישי' },
  { date: '2026-12-12', name: 'חופשת חנוכה', type: 'break', description: 'חופשת חנוכה - אין פעילות צהרון בשבת' },

  // --- פורים תשפ"ז (פורים חופש, שושן פורים קייטנה) ---
  { date: '2027-03-23', name: 'פורים', type: 'holiday', description: 'פורים - אין פעילות צהרון' },
  { date: '2027-03-24', name: 'קייטנת פורים', type: 'camp', description: 'שושן פורים - פעילות מלאה בצהרון' },

  // --- פסח תשפ"ז (קייטנה ג'-ה' ו-א'-ב', ללא שישי-שבת) ---
  { date: '2027-04-13', name: 'קייטנת פסח', type: 'camp', description: 'פעילות מלאה בצהרון' },
  { date: '2027-04-14', name: 'קייטנת פסח', type: 'camp', description: 'פעילות מלאה בצהרון' },
  { date: '2027-04-15', name: 'קייטנת פסח', type: 'camp', description: 'פעילות מלאה בצהרון' },
  { date: '2027-04-16', name: 'חופשת פסח', type: 'break', description: 'חופשת פסח - אין פעילות צהרון בשישי' },
  { date: '2027-04-17', name: 'חופשת פסח', type: 'break', description: 'חופשת פסח - שבת' },
  { date: '2027-04-18', name: 'קייטנת פסח', type: 'camp', description: 'פעילות מלאה בצהרון' },
  { date: '2027-04-19', name: 'קייטנת פסח', type: 'camp', description: 'פעילות מלאה בצהרון' },

  // --- חופשת פסח וחג הפסח (אין פעילות צהרון) ---
  { date: '2027-04-20', name: 'חופשת פסח', type: 'break', description: 'חופשת פסח - אין פעילות צהרון' },
  { date: '2027-04-21', name: 'ערב פסח', type: 'holiday', description: 'ערב פסח - אין פעילות צהרון' },
  { date: '2027-04-22', name: 'פסח א\'', type: 'holiday', description: 'חג הפסח יום ראשון - אין פעילות צהרון' },
  { date: '2027-04-23', name: 'חול המועד פסח', type: 'holiday', description: 'חול המועד פסח - אין פעילות צהרון' },
  { date: '2027-04-24', name: 'חול המועד פסח', type: 'holiday', description: 'חול המועד פסח - שבת' },
  { date: '2027-04-25', name: 'חול המועד פסח', type: 'holiday', description: 'חול המועד פסח - אין פעילות צהרון' },
  { date: '2027-04-26', name: 'חול המועד פסח', type: 'holiday', description: 'חול המועד פסח - אין פעילות צהרון' },
  { date: '2027-04-27', name: 'ערב שביעי של פסח', type: 'holiday', description: 'ערב שביעי של פסח - אין פעילות צהרון' },
  { date: '2027-04-28', name: 'פסח ז\'', type: 'holiday', description: 'שביעי של פסח - אין פעילות צהרון' },

  // --- יום הזיכרון לחללי צה"ל (לימודים עד 12:00, אין פעילות צהרון) ---
  { date: '2027-05-11', name: 'יום הזיכרון לחללי צה"ל', type: 'special', description: 'לימודים מסתיימים בשעה 12:00 - אין פעילות צהרון' },

  // --- יום העצמאות תשפ"ז (אין פעילות צהרון) ---
  { date: '2027-05-12', name: 'יום העצמאות', type: 'holiday', description: 'יום העצמאות תשפ"ז - אין פעילות צהרון' },

  // --- שבועות תשפ"ז (אין פעילות צהרון) ---
  { date: '2027-06-10', name: 'ערב שבועות', type: 'holiday', description: 'ערב חג השבועות - אין פעילות צהרון' },
  { date: '2027-06-11', name: 'חג השבועות', type: 'holiday', description: 'חג השבועות תשפ"ז - אין פעילות צהרון' },
  { date: '2027-06-12', name: 'איסרו חג שבועות', type: 'break', description: 'איסרו חג שבועות - שבת' }
]

// ============================================================================
// Fast O(1) Lookup Maps and Helper Utilities
// ============================================================================

export const ALL_FALLBACK_CALENDAR_ITEMS: FallbackCalendarItem[] = [
  ...CALENDAR_2025_2026,
  ...CALENDAR_2026_2027
]

export const FALLBACK_CALENDAR_MAP = new Map<string, FallbackCalendarItem>(
  ALL_FALLBACK_CALENDAR_ITEMS.map(item => [item.date, item])
)

/**
 * Filtered array of all camp dates across supported school years
 */
export const FALLBACK_CAMP_DATES = ALL_FALLBACK_CALENDAR_ITEMS.filter(item => item.type === 'camp')
